export default "__VITE_ASSET__68bf1a6a__"